import { createDeferredPromise } from '@colonist/utils';
export class UITurnstile {
    static async generateClearanceCookie() {
        await this.waitUntilTurnstileIsLoaded();
        return new Promise((resolve, reject)=>{
            turnstile.reset();
            turnstile.execute('#turnstile-widget', {
                callback: (token, preClearanceObtained)=>resolve(preClearanceObtained),
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'error-callback': reject
            });
        });
    }
    static async getToken() {
        await this.waitUntilTurnstileIsLoaded();
        return new Promise((resolve, reject)=>{
            turnstile.reset();
            turnstile.execute('#turnstile-widget', {
                callback: (token)=>resolve(token),
                // eslint-disable-next-line @typescript-eslint/naming-convention
                'error-callback': reject
            });
        });
    }
    static isChallengeResponse(responseHeaders) {
        // https://developers.cloudflare.com/waf/reference/cloudflare-challenges/#detecting-a-challenge-page-response
        return responseHeaders['cf-mitigated'] == 'challenge';
    }
    static isTokenResponse(responseHeaders) {
        return responseHeaders['cf-mitigated'] == 'token';
    }
    static async obtainPreClearanceCookie() {
        if (this.preClearanceCookiePromise != undefined) return this.preClearanceCookiePromise;
        this.preClearanceCookiePromise = createDeferredPromise();
        // eslint-disable-next-line no-restricted-syntax
        void this.getClearanceCookie().then(()=>{
            var _this_preClearanceCookiePromise;
            return (_this_preClearanceCookiePromise = this.preClearanceCookiePromise) === null || _this_preClearanceCookiePromise === void 0 ? void 0 : _this_preClearanceCookiePromise.resolve();
        }, (error)=>{
            var _this_preClearanceCookiePromise;
            return (_this_preClearanceCookiePromise = this.preClearanceCookiePromise) === null || _this_preClearanceCookiePromise === void 0 ? void 0 : _this_preClearanceCookiePromise.reject(error);
        }).finally(()=>this.preClearanceCookiePromise = undefined);
        return this.preClearanceCookiePromise;
    }
    static async getClearanceCookie() {
        const maxAttempts = 5;
        let attempt = 1;
        while(attempt <= maxAttempts){
            try {
                const success = await this.generateClearanceCookie();
                if (success) return;
            } catch (error) {
                if (attempt == maxAttempts) {
                    throw error;
                }
            }
            attempt += 1;
        }
    }
    static async waitUntilTurnstileIsLoaded() {
        if (this.isTurnstileLoaded) return;
        const result = createDeferredPromise();
        setTimeout(()=>{
            result.reject(new Error('Unable to load required script'));
        }, 5000);
        const checkTurnstileLoaded = setInterval(()=>{
            if (window['turnstile'] == undefined) return;
            if (turnstile.loaded != true) return;
            this.isTurnstileLoaded = true;
            result.resolve();
        }, 5);
        void result.finally(()=>clearInterval(checkTurnstileLoaded));
        return result;
    }
}
UITurnstile.isTurnstileLoaded = false;
